import mask from '../directive/mask';

export default ({ app }) => {
  app.directive('aevi-mask', mask);
};
